import { trackAnalytics } from "services/analytics";
import { getFormDataValues } from "../utils/utils";

export const faTalkToAnExpertClick = ({ flowName, formData, segment }) => {
  const { fullName, mobileNumber, companyName, companyEmail } = getFormDataValues(formData);
  flowName = flowName?.replace("&", "and").toLowerCase();
  trackAnalytics({
    eVar9: `b2b${flowName ? "|" + flowName : ""}|talk to an expert${segment ? "|" + segment : ""}`,
    prop0: `b2b${flowName ? "|" + flowName : ""}`,
    prop13: flowName,
    prop17: fullName,
    prop14: mobileNumber,
    prop35: companyName,
    prop15: companyEmail,
  });
};

export const faTalkToAnExpertLoad = (flowName) => {
  flowName = flowName?.replace("&", "and").toLowerCase();
  trackAnalytics({
    eVar9: `b2b${flowName ? "|" + flowName : ""}|talk to an expert`,
    prop0: `b2b${flowName ? "|" + flowName : ""}`,
    prop13: flowName,
  });
};
